// extracted by mini-css-extract-plugin
export var background = "index-module--background--rjC8X";
export var contain = "index-module--contain--B97Lq";
export var container = "index-module--container--CmWm-";
export var infoButton = "index-module--infoButton--WKoTk";
export var open = "index-module--open--y2e+z";
export var projectList = "index-module--projectList--xm7-V";
export var projects = "index-module--projects--UvATK";
export var texts = "index-module--texts--N2A4D";